import { render, staticRenderFns } from "./UpdateAdministrativeApproval.vue?vue&type=template&id=62c899b2"
import script from "./UpdateAdministrativeApproval.vue?vue&type=script&lang=js"
export * from "./UpdateAdministrativeApproval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports